import styled, { css } from 'styled-components';

const CompactDropdownStyled = styled.div`
  ${() => {
    return css`
      margin-right: 1em;
      .compact-dropdown__select--wrapper {
        position: relative;
      }
      .compact-dropdown__select {
        width: 7.563em;
        height: 2em;
        border: none;
        padding: 0.25em 1.5em 0.25em 0.5em;
        font-weight: 400;
        font-size: 0.875em;
        line-height: 1.5em;
        color: var(--color-neutral-70);
        background: transparent;
        -moz-appearance: none; /* Firefox */
        -webkit-appearance: none; /* Safari and Chrome */
        appearance: none;
        cursor: pointer;
      }
      .compact-dropdown__triangle {
        position: absolute;
        right: 0;
        top: 0.25em;
        pointer-events: none;
      }
    `;
  }}
`;

export default CompactDropdownStyled;
